
define(
	'Tavano.TT_TariffMessage.TariffMessage'
	, [
		'Tavano.TT_TariffMessage.TariffMessage.View'
	]
	, function (
		TariffMessageView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {

				var layout = container.getComponent('Layout');
				var pdp = container.getComponent('PDP');

				if (layout && pdp) {
					layout.addChildView('Product.Price', function () {
						return new TariffMessageView({ container: container, pdp: pdp });
					});
				}
			}
		};
	});
